import { ReactNode } from "react";
import styles from "./BottomRow.module.css";

type BottomRowProps = {
  children: ReactNode;
};

function BottomRow({ children }: BottomRowProps) {
  return <div className={styles["root"]}>{children}</div>;
}

export default BottomRow;
